import { Link } from 'react-router-dom';
import Container from 'react-bootstrap/esm/Container';
import Row from 'react-bootstrap/esm/Row';
import Col from 'react-bootstrap/esm/Col';
import {
 FaPhone,
 FaWhatsapp,
 FaWaze,
 FaFacebook,
 FaHome,
 FaEnvelope,
} from 'react-icons/fa';

const Links = ({ data }) => {
 const {
  linkWaze,
  linkMail,
  linkWhatsapp,
  linkPhone,
  linkNehasim,
  linkFacebook,
 } = data;

 return (
  <div>
   <Container className='lh-1'>
    <Row className='pt-4'>
     <Col>
      <Link to={linkMail}>
       <FaEnvelope className='text-blue' size={30} />
      </Link>
      <p>מייל</p>
     </Col>

     <Col>
      <Link to={linkWhatsapp}>
       <FaWhatsapp className='text-blue' size={30} />
      </Link>
      <p>וואטסאפ</p>
     </Col>

     <Col>
      <Link to={linkPhone}>
       <FaPhone className='text-blue' size={30} />
      </Link>
      <p>חייג אלי</p>
     </Col>
    </Row>

    <Row className='pt-1'>
     <Col>
      <Link to={linkWaze}>
       <FaWaze className='text-blue' size={30} />
      </Link>
      <p>נווט</p>
     </Col>

     <Col>
      <Link to={linkNehasim}>
       <FaHome className='text-blue' size={30} />
      </Link>
      <p>מאגר נכסים</p>
     </Col>

     <Col>
      <Link to={linkFacebook}>
       <FaFacebook className='text-blue' size={30} />
      </Link>
      <p>פייסבוק</p>
     </Col>
    </Row>
   </Container>
  </div>
 );
};

export default Links;
